import React from "react";
import TagAdminPanel from "../components/Admin/TagAdminPanel";

export default function AdminTagsPage() {
  return <TagAdminPanel />;
}
